import React, { useEffect, useState } from "react";
import classes from "../HomeScreen/HomeScreen.module.css";
import searchicon from "../../Assests/Images/search.png";
import crossimg from "../../Assests/Images/wrong.png";
import CommonButton from "../../Components/Buttons/CommonButton";
import FilterUser from "../../Components/Filters/FilterUser";
import { getDisplayCount } from "../../Components/Tables/DisplayTableDataCount";
import Newcommontable from "../../Components/Tables/NewCommonTable";
import Commonpagination from "../../Components/Tables/CommonPagination";
import UserTable from "../../Components/Tables/UserTable";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { DeleteUserData, UseListService } from "../../Services/ApiServices";
import {
  CatchMessage,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import UserCreateModal from "../../Modals/User/UserCreateModal";
import ChangePasswordModal from "../../Modals/ChangePasswordModal";
import DeleteConfirmation from "../../Modals/DeleteConfirmation";
import Loader from "../../SharedComponents/Loader/Loader";

function Userdetails(value: any) {
  const { loading } = useSelector((state: any) => state.Dashboard);
  const [showfilter, setShowFilter] = useState(false);
  const [showModal, setShowModal] = useState<any>({
    isView: false,
    item: "",
    create: "",
  });
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [userList, setUserList] = useState<any>([]);
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
  });
  const { items, page, total_count, size } = userList;
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [Values, setValues] = useState({
    name: "",
    mobile_no: "",
  });
  const [changePassword, setChangePassword] = useState({
    isView: false,
    item: "",
  });
  const [userDevice, setUserDevice] = useState<any>({
    isView: false,
    item: {},
  });
  const [DropDowns, setDropDowns] = useState({
    Device: [],
  });

  useEffect(() => {
    if (LoginData !== null) {
      handleGetUserList();
    }
  }, [LoginData]);

  const ResetForm = () => {
    handleGetUserList(1, pageSize, value, true);
    setValues({
      name: "",
      mobile_no: "",
    });
  };

  const handleGetUserList = (
    page = 1,
    size = 10,

    filterData?: any,
    isreset = false
  ) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };

    const WithValues = !isreset
      ? Object.assign(finalObj, filterData ? filterData : Values)
      : finalObj;

    UseListService(page, size, JSONtoformdata(WithValues))
      .then(async (res) => {
        if (res.data.status === 1) {
          setUserList(res.data.data);
          if (filterData && !isreset) {
            setValues(filterData);
            setShowConfirmModal({ isView: false, item: "" });
          }
          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleGetUserList(1, size);
  };

  const DeleteDevice = (id: number) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      user_id: id,
    };
    DeleteUserData(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setPageInd(
            userList?.items?.length === 1 && userList?.page !== 1
              ? pageind - 1
              : pageind
          );
          handleGetUserList(
            userList?.items?.length === 1 && userList?.page !== 1
              ? userList?.page - 1
              : userList?.page,
            pageSize,
            Values
          );
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handleCancel = () => {
    setShowConfirmModal({ isView: false, item: "" });
    setShowModal({
      isView: false,
      item: "",
      create: "",
    });
    setChangePassword({ isView: false, item: "" });
    setUserDevice({ isView: false, item: {} });
  };

  return (
    <>
      <Loader isLoader={loading} />
      {showModal?.isView ? (
        <UserCreateModal
          handleSuccess={(type) => {
            handleGetUserList(type === "create" ? 1 : page, size);
            // setPageInd(0);
            // setpageSize(10);
          }}
          Action={showModal?.create}
          onCancel={handleCancel}
          item={showModal?.item}
          closable={!showModal?.isView}
          open={showModal?.isView}
          // DropDowns={DropDowns}
          // DropdownMethods={{
          //   getBaudrateDropDown,
          //   getParityDropDown,
          //   getDataBitsDropDown,
          // }}
        />
      ) : null}

      {/* {userDevice?.isView ? (
        <AddUserdevicemodal
          handleSuccess={() => {
            handleGetUserList(1, 10);
          }}
          onCancel={handleCancel}
          item={userDevice?.item}
          closable={!userDevice?.isView}
          open={userDevice?.isView}
          DropDowns={DropDowns}
          DropdownMethods={{
            getDeviceDropDown,
          }}
        />
      ) : null} */}

      {changePassword?.isView ? (
        <ChangePasswordModal
          handleSuccess={() => {
            handleGetUserList(1, 10);
          }}
          onCancel={handleCancel}
          item={changePassword?.item}
          closable={!changePassword?.isView}
          open={changePassword?.isView}
          isuserpassword={false}
        />
      ) : null}

      {showConfirmModal?.isView ? (
        <DeleteConfirmation
          handleSuccess={() => {
            handleGetUserList();
            DeleteDevice(showConfirmModal?.item?.id);
          }}
          itemName={showConfirmModal?.item?.name}
          Delete={true}
          open={showConfirmModal?.isView}
          closable={!showConfirmModal?.isView}
          onCancel={handleCancel}
        />
      ) : null}

      <div className="header_container justify-content-end">
        {/* <h3>Device</h3> */}
        <div className="header_right_container">
          <div className="search_bg">
            {!showfilter ? (
              <img
                src={searchicon}
                className="search_icon"
                onClick={() => setShowFilter(true)}
                alt="searchicon"
              />
            ) : (
              <img
                src={crossimg}
                className="search_icon"
                onClick={() => setShowFilter(false)}
                alt="crossimg"
              />
            )}
          </div>
          <CommonButton
            name="Create User"
            onClick={() => {
              setShowModal({ ...showModal, isView: true, create: "Create" });
            }}
            type="button"
            classname="create_btn"
            style={{ padding: "6px 12px", maxWidth: "126px" }}
          />
        </div>
      </div>
      <div className={classes.table_container_background}>
        <FilterUser
          showfilter={showfilter}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleGetUserList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          ResetForm={ResetForm}
        />
        <div>
          {getDisplayCount(userList?.page, pageSize, userList?.total_count)}
        </div>
        {/* <DeviceTable
          userList={userList}
          pageSize={pageSize}
          pageind={pageind}
          GetList={handleGetUserList}
          setpageSize={setpageSize}
          setPageInd={setPageInd}
          columns={columns}
        /> */}
        <Newcommontable
          Children={
            <UserTable
              Data={userList}
              pageSize={pageSize}
              pageind={pageind}
              GetList={handleGetUserList}
              setpageSize={setpageSize}
              setPageInd={setPageInd}
              OBJHead={[
                "S.No",
                "Name",
                "E-mail",
                "Mobile",
                "Created At",
                "Action",
              ]}
              OBJKeys={["name", "email", "phone", "created_at"]}
              setShowModal={setShowModal}
              setShowConfirmModal={setShowConfirmModal}
              setChangePassword={setChangePassword}
              setUserDevice={setUserDevice}
              userDevice={userDevice}
            />
          }
        />

        <div>
          <Commonpagination
            onShowSizeChange={Changesize} ///call when page size click
            total={total_count}
            current={page}
            pageSize={size}
            onChange={(e, size) => {
              ///call when page number click
              if (size === pageSize) {
                handleGetUserList(e, size);
              }
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Userdetails;
